import actions from '../../actionTypes';

export default (orgs, orgCount) => {
  return {
    type: actions.SET_ORGS,
    orgs,
    orgCount
  };
};



// WEBPACK FOOTER //
// ./src/reducers/organizations/actions/setOrgs.js